import { render, staticRenderFns } from "./contract_draft_work_construction_ru.vue?vue&type=template&id=2c6a95ac&scoped=true"
import script from "./contract_draft_work_construction_ru.vue?vue&type=script&lang=js"
export * from "./contract_draft_work_construction_ru.vue?vue&type=script&lang=js"
import style0 from "./contract_draft_work_construction_ru.vue?vue&type=style&index=0&id=2c6a95ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a95ac",
  null
  
)

export default component.exports